import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import immutableCreatorSelector from '../../../selectors/immutableCreatorSelector';

import DailyTasksComplete from './DailyTasksComplete';

// TODO: Need to connect whatever reducer will hold the "daily task complete" and peel out the specific report according to the URL (should be params > reportId)

const DailyTasksCompleteContainerSelector = immutableCreatorSelector([], () => {
  return {};
});

@connect(DailyTasksCompleteContainerSelector)
export default class DailyTasksCompleteContainer extends Component {
  static propTypes = {
    dispatch: PropTypes.func.isRequired,
  };

  componentDidMount() {}

  render() {
    return <DailyTasksComplete {...this.props} />;
  }
}



// WEBPACK FOOTER //
// ./src/views/ProjectSettings/DailyTasksComplete/DailyTasksCompleteContainer.js